import {keepPreviousData, queryOptions, useQuery} from "@tanstack/react-query";

import * as apiClient from "@/lib/api";
import {ActiveAdvisersNumber} from "@/lib/types/active-advisers";
import {QUERY_KEY_ACTIVE_ADVISERS_NUMBER} from "@/utils/keys";

function fetchActiveAdvisersNumber(): Promise<ActiveAdvisersNumber> {
  return apiClient.get('/firm/dashboard/activity-levels/active-professionals')
}

export const activeAdvisersNumberQueryOptions = () => queryOptions({
  queryKey: [QUERY_KEY_ACTIVE_ADVISERS_NUMBER],
  queryFn: fetchActiveAdvisersNumber,
  placeholderData: keepPreviousData
})

export const useActiveAdvisersNumber = () => {
  return useQuery(activeAdvisersNumberQueryOptions())
}
